import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import "./css/folderView.css";
import { FiTrash2 } from "react-icons/fi";
import { LuTrash2 } from "react-icons/lu";
import { FaSave } from "react-icons/fa";

const UploadsGallery = () => {
  const [uploads, setUploads] = useState({});
  const [flatFiles, setFlatFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [previewIndex, setPreviewIndex] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  

  const navigate = useNavigate();
  const location = useLocation();
  const folderName = location.pathname.split("/folder/")[1] || "";

  useEffect(() => {
    fetchUploads();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return "Unknown Date";
    const date = new Date(timestamp);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const fetchUploads = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://lifoura.com/get_uploaded.php");
      const data = await res.json();

      if (data.files) {
        const filtered = data.files.filter(file =>
          file.file_name.startsWith(`${folderName}-`)
        );

        const grouped = {};
        filtered.forEach(file => {
          const date = formatDate(file.uploaded_at);
          if (!grouped[date]) grouped[date] = [];
          grouped[date].push(file);
        });

        setUploads(grouped);
        setFlatFiles(filtered);
      }
    } catch (error) {
      alert("Failed to fetch files.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const isImage = (name) => /\.(jpg|jpeg|png|gif|webp)$/i.test(name);
  const isVideo = (name) => /\.(mp4|mov|webm|ogg)$/i.test(name);

  const toggleSelectFile = (fileName) => {
    setSelectedFiles(prev =>
      prev.includes(fileName)
        ? prev.filter(f => f !== fileName)
        : [...prev, fileName]
    );
  };
  
const handleSaveFile = async (file) => {
  const displayName = file.file_name.replace(`${folderName}-`, "");
  const mediaUrl = file.url + "?t=" + Date.now();

  try {
    const response = await fetch(mediaUrl, { mode: "cors" }); // important
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = displayName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url); // Clean up
  } catch (error) {
    alert("Failed to download the file.");
    console.error("Download error:", error);
  }
};



const handleDeleteFile = async (file) => {
  if (!window.confirm(`Delete "${file.file_name}"?`)) return;

  const [folder, ...rest] = file.file_name.split('-');
  const fileName = rest.join('-'); // in case filename also had dashes
  const filePath = `${folder}/${fileName}`;

  try {
    const res = await fetch("https://lifoura.com/delete_file.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ file_name: filePath }), // ✅ correct format
    });

    const result = await res.json();
    console.log("Delete result:", result);

    if (result.success) {
      alert("File deleted.");
      fetchUploads(); // refresh list
    } else {
      alert("Delete failed: " + (result.error || "Unknown error"));
    }
  } catch (error) {
    alert("Error deleting file.");
    console.error(error);
  }
};




const saveSelected = async () => {
  if (selectedFiles.length === 0) return alert("No files selected.");

  for (const file of flatFiles) {
    if (selectedFiles.includes(file.file_name)) {
      console.log("Downloading:", file.url);
      await handleSaveFile(file);
      await new Promise((r) => setTimeout(r, 300));
    }
  }

  alert("📥 Selected files saved.");
};


const deleteSelected = async () => {
  if (selectedFiles.length === 0) {
    alert("No files selected.");
    return;
  }

  if (!window.confirm("Are you sure you want to delete the selected files?")) {
    return;
  }

  try {
    const deleteResults = [];

    for (const file of selectedFiles) {
      // Parse folder and file name
      const [folder, ...rest] = file.split('-');
      const fileName = rest.join('-'); // handles filenames with dashes
      const filePath = `${folder}/${fileName}`;

      const res = await fetch("https://lifoura.com/delete_file.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ file_name: filePath }),
      });

      const result = await res.json();
      deleteResults.push({ file: filePath, success: result.success });

      if (!result.success) {
        console.warn(`Failed to delete: ${filePath}`, result);
      }
    }

    alert("Selected files processed for deletion.");
    setSelectedFiles([]);
    fetchUploads(); // refresh list
  } catch (error) {
    alert("Error deleting selected files.");
    console.error(error);
  }
};



  const openPreview = (index) => setPreviewIndex(index);
  const closePreview = () => setPreviewIndex(null);
  const goNext = () => setPreviewIndex((prev) => (prev + 1) % flatFiles.length);
  const goPrev = () => setPreviewIndex((prev) => (prev - 1 + flatFiles.length) % flatFiles.length);

  return (
    <div className="uploads-gallery-container">
      <header className="uploads-header">
        <div className="logo">
          <img src="/assets/lifoura-04.png" className="logo-img" />
        </div>
        <div className="bulk-actions">
          <button onClick={saveSelected} className="p-1 border border-gray-400 rounded hover:bg-gray-100 transition"
    title="Download"><FaSave /> Save</button>
          <button onClick={deleteSelected} className="p-1 border border-black rounded text-red-600 hover:bg-red-100 transition"
    title="Delete"><FiTrash2 /> Delete</button>
          <button onClick={() => setSelectedFiles(flatFiles.map(f => f.file_name))} className="p-1 border border-black rounded text-red-600 hover:bg-red-100 transition"
    title="Select all" >✔ Select All</button>
        </div>
      </header>
 <h2 className="upload-h2">📁 {folderName}</h2>
      {loading ? (
        <div className="loader">⏳ Loading files...</div>
      ) : (
        Object.entries(uploads)
          .sort((a, b) => new Date(b[0]) - new Date(a[0]))
          .map(([date, files]) => (
            <div key={date}>
              <h3 className="upload-date-label">{date}</h3>
              <div className="uploads-grid">
                {files.map((file, index) => {
                  const displayName = file.file_name.replace(`${folderName}-`, "");
                  const mediaUrl = file.url + "?t=" + Date.now();
                  const selected = selectedFiles.includes(file.file_name);

                  return (
                    <motion.div
                      key={index}
                      className={`upload-card ${selected ? "selected" : ""}`}
                      whileHover={{ scale: 1.04 }}
                    >
                      <input
                        type="checkbox"
                        className="file-checkbox"
                        checked={selected}
                        onChange={() => toggleSelectFile(file.file_name)}
                      />

                      <div
                        className="media-wrapper"
                        onClick={() => openPreview(flatFiles.findIndex(f => f.file_name === file.file_name))}
                      >
                        {isImage(file.file_name) ? (
                          <img src={mediaUrl} alt={displayName} className="upload-media" />
                        ) : isVideo(file.file_name) ? (
                          <video src={mediaUrl} className="upload-media" controls preload="metadata" />
                        ) : (
                          <div className="unsupported-file">Unsupported</div>
                        )}
                      </div>

                      <div className="file-name" title={displayName}>{displayName}</div>

                      <div className="file-actions">
                        <button onClick={() => handleSaveFile(file)}className="p-1 border border-gray-400 rounded hover:bg-gray-100 transition"
    title="Save"><FaSave size={18} color=" rgb(155, 138, 109)" /></button>
                        <button onClick={() => handleDeleteFile(file)} className="p-1 border border-black rounded text-red-600 hover:bg-red-100 transition"
    title="Delete"><LuTrash2 size={18} color="black"/></button>
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          ))
      )}

      <AnimatePresence>
        {previewIndex !== null && flatFiles[previewIndex] && (
          <motion.div
            className="preview-overlay"
            onClick={closePreview}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="carousel-modal"
              onClick={(e) => e.stopPropagation()}
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
            >
              <button onClick={goPrev} className="nav-btn prev-btn">←</button>

              <div className="carousel-media">
                {isImage(flatFiles[previewIndex].file_name) ? (
                  <img src={flatFiles[previewIndex].url} alt="Preview" />
                ) : (
                  <video src={flatFiles[previewIndex].url} controls />
                )}
              </div>

              <button onClick={goNext} className="nav-btn next-btn">→</button>
              <button className="close-btn" onClick={closePreview}>✖</button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default UploadsGallery;
